import React from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import moment from 'moment';
import translate from '../../../commonComponents/translate';
import ClientList from '../../../commonComponents/lists/ClientSideList';
import Modal from '../../../commonComponents/modal/Modal';
import {
  newFormatPrice,
  resolveDocumentUrl,
} from '../../../services/utilityFunctions';

const CreditNotesModal = ({ t, onClose, creditNotes, currency }) => {
  const columns = [
    {
      field: 'number',
      textAlign: 'center',
      title: t('shop.creditNote.number'),
      width: 200,
      sortable: false,
    },
    {
      field: 'date',
      textAlign: 'center',
      title: t('date'),
      width: 150,
      sortable: false,
      template: ({ date }) => renderToStaticMarkup(
        <>{moment(date).format('DD MMM YYYY - HH:mm')}</>,
      ),
    },
    {
      field: 'amount',
      textAlign: 'center',
      title: t('shop.creditNote.amount'),
      width: 100,
      sortable: false,
      template: ({ amount }) => renderToStaticMarkup(
        <div className="no-wrap-value">{newFormatPrice(amount, true, currency)}</div>,
      ),
    },
    {
      field: 'link',
      textAlign: 'center',
      title: '',
      width: 100,
      sortable: false,
      template: ({ link }) => renderToStaticMarkup(
        <>
          <a
            href={resolveDocumentUrl(link)}
            className=""
            target="_blank"
            rel="noreferrer"
          >
            <span>
              <i className="fa fa-download" />
              <span className="btn-text">{t('shop.download')}</span>
            </span>
          </a>
        </>,
      ),
    },
  ];
  return (
    <>
      <Modal onClose={onClose} id="creditNotesModal">
        <div className="modal-dialog modal-lg user-filter">
          <div className="modal-content">
            <div className="container-fluid">
              <div className="modal-header">
                <h5 className="modal-title">{t('shop.order_download.creditNotes.list')}</h5>
                <button type="button" onClick={onClose} className="btn-close">
                  <span>x</span>
                </button>
              </div>
              <div className="modal-body">
                <ClientList data={creditNotes} columns={columns} id="creditNotes" loading={false} />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                {t('cancel')}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

CreditNotesModal.propTypes = {
  t: PropTypes.func.isRequired,
  creditNotes: PropTypes.shape({
    date: PropTypes.number,
    link: PropTypes.string,
    number: PropTypes.string,
    amount: PropTypes.number,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
};
CreditNotesModal.defaultProps = {
};

export default translate(CreditNotesModal);
